export const defaultProducts = {
	SpecialConsumptionProducst: [], //Hàng hóa dịch vụ loại thuế tiêu thụ đặc biệt
	EnviromentTaxProducts: [], //Hàng hóa thuộc loại thuế bảo vệ môi trường
	EnviromentFeesProducts: [], //Loại kháng sản thuộc loại phí bảo vệ môi trường
	FeesChargesProducts: [], //Loại phí, lệ phí
	TypeWorks: []
};

export default {
	...defaultProducts
};
